import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=afc74dda&scoped=true&"
import script from "./Promotion.js?vue&type=script&lang=js&"
export * from "./Promotion.js?vue&type=script&lang=js&"
import style0 from "./promotion.scss?vue&type=style&index=0&id=afc74dda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc74dda",
  null
  
)

export default component.exports